/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoModelsUserAlphabet,
    EfsMelcoModelsUserAlphabetFromJSON,
    EfsMelcoModelsUserAlphabetFromJSONTyped,
    EfsMelcoModelsUserAlphabetToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoModelsDesignLetteringElement
 */
export interface EfsMelcoModelsDesignLetteringElement {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    alphabet_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    angle?: number;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    width_factor?: number;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    slant_angle?: number;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    tracking?: number;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    rotation_direction?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    layout_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    justification?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    radius?: number;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    height?: number;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    horizontal_stitch_order?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    vertical_stitch_order?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    connection_type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    continuous_underlay?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    default_text?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    text_max_length?: number;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    default_alphabet_id?: string | null;
    /**
     * 
     * @type {Array<EfsMelcoModelsUserAlphabet>}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    alphabet_list?: Array<EfsMelcoModelsUserAlphabet> | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsDesignLetteringElement
     */
    renderer_index?: number;
}

export function EfsMelcoModelsDesignLetteringElementFromJSON(json: any): EfsMelcoModelsDesignLetteringElement {
    return EfsMelcoModelsDesignLetteringElementFromJSONTyped(json, false);
}

export function EfsMelcoModelsDesignLetteringElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsDesignLetteringElement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': !exists(json, 'text') ? undefined : json['text'],
        'alphabet_name': !exists(json, 'alphabet_name') ? undefined : json['alphabet_name'],
        'angle': !exists(json, 'angle') ? undefined : json['angle'],
        'width_factor': !exists(json, 'width_factor') ? undefined : json['width_factor'],
        'slant_angle': !exists(json, 'slant_angle') ? undefined : json['slant_angle'],
        'tracking': !exists(json, 'tracking') ? undefined : json['tracking'],
        'rotation_direction': !exists(json, 'rotation_direction') ? undefined : json['rotation_direction'],
        'layout_type': !exists(json, 'layout_type') ? undefined : json['layout_type'],
        'justification': !exists(json, 'justification') ? undefined : json['justification'],
        'radius': !exists(json, 'radius') ? undefined : json['radius'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'horizontal_stitch_order': !exists(json, 'horizontal_stitch_order') ? undefined : json['horizontal_stitch_order'],
        'vertical_stitch_order': !exists(json, 'vertical_stitch_order') ? undefined : json['vertical_stitch_order'],
        'connection_type': !exists(json, 'connection_type') ? undefined : json['connection_type'],
        'continuous_underlay': !exists(json, 'continuous_underlay') ? undefined : json['continuous_underlay'],
        'default_text': !exists(json, 'default_text') ? undefined : json['default_text'],
        'text_max_length': !exists(json, 'text_max_length') ? undefined : json['text_max_length'],
        'default_alphabet_id': !exists(json, 'default_alphabet_id') ? undefined : json['default_alphabet_id'],
        'alphabet_list': !exists(json, 'alphabet_list') ? undefined : (json['alphabet_list'] === null ? null : (json['alphabet_list'] as Array<any>).map(EfsMelcoModelsUserAlphabetFromJSON)),
        'renderer_index': !exists(json, 'renderer_index') ? undefined : json['renderer_index'],
    };
}

export function EfsMelcoModelsDesignLetteringElementToJSON(value?: EfsMelcoModelsDesignLetteringElement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'alphabet_name': value.alphabet_name,
        'angle': value.angle,
        'width_factor': value.width_factor,
        'slant_angle': value.slant_angle,
        'tracking': value.tracking,
        'rotation_direction': value.rotation_direction,
        'layout_type': value.layout_type,
        'justification': value.justification,
        'radius': value.radius,
        'height': value.height,
        'horizontal_stitch_order': value.horizontal_stitch_order,
        'vertical_stitch_order': value.vertical_stitch_order,
        'connection_type': value.connection_type,
        'continuous_underlay': value.continuous_underlay,
        'default_text': value.default_text,
        'text_max_length': value.text_max_length,
        'default_alphabet_id': value.default_alphabet_id,
        'alphabet_list': value.alphabet_list === undefined ? undefined : (value.alphabet_list === null ? null : (value.alphabet_list as Array<any>).map(EfsMelcoModelsUserAlphabetToJSON)),
        'renderer_index': value.renderer_index,
    };
}


